import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ParentProductFilters from "./parent-product-filters";
import {searchParentProducts, updateParentProducts} from "../../services/parent-product-data-service";
import {
    PARENT_PRODUCT_FIELD_LIST,
    PRODUCT_DETAIL_KEY,
    PRODUCT_SIZE_FILTER_LIST,
    SAVE_POD_TIME_DELAY
} from "../../constants/pod.constant";
import {convertInchToPixel} from "../../utils/dimension-util";

const parentProductFields = PARENT_PRODUCT_FIELD_LIST;

const ParentProductList = ({podDetail}) => {
    const [initialStep, setInitialStep] = useState(true);
    const [enableEdit, setEnableEdit] = useState(false);
    const [parentProductList, setParentProductList] = useState(null);
    const [updatedParentProductsMap, setUpdatedParentProductsMap] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(null);
    let [changesCount, setChangesCount] = useState(0);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            searchParentProductList();
        }
    }, [initialStep]);

    const searchParentProductList = async () => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: podDetail?.id});

        _.forIn(filterCriteria, (value, field) => {
            if (!_.isEmpty(value)) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        const existingParentProducts = await searchParentProducts(searchCriteriaList);
        setParentProductList(_.orderBy(existingParentProducts, ['productType', 'category', 'name']));

        /*console.log({podDetail});
        console.log('searchParentProductList: ', _.orderBy(existingParentProducts, ['productType', 'category', 'name']));*/
    }

    const handleDetailChanges = (event, rowIndex, parentProduct) => {
        const {name, value} = event.target;
        parentProduct[name] = value;

        if (name === PRODUCT_DETAIL_KEY.HEIGHT_INCH) {
            parentProduct[PRODUCT_DETAIL_KEY.HEIGHT_PIXEL] = convertInchToPixel(value);
        } else if (name === PRODUCT_DETAIL_KEY.WIDTH_INCH) {
            parentProduct[PRODUCT_DETAIL_KEY.WIDTH_PIXEL] = convertInchToPixel(value);
        } else if (name === PRODUCT_DETAIL_KEY.SIZE_TYPE) {
            parentProduct.isMultiMeasurement = (value === 'multi-measurements');
        }

        const tempUpdatedParentProductsMap = {...updatedParentProductsMap};
        tempUpdatedParentProductsMap[rowIndex] = parentProduct;
        setUpdatedParentProductsMap(tempUpdatedParentProductsMap);
    }

    useEffect(() => {
        incrementChangesCount();
    }, [updatedParentProductsMap]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    saveUpdatedParentProducts();
                }

            }, SAVE_POD_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const saveUpdatedParentProducts = async () => {
        const tempUpdatedParentProductsMap = {...updatedParentProductsMap};
        const updateParentProductList = _.values(tempUpdatedParentProductsMap);

        if (!_.isEmpty(updateParentProductList)) {
            // console.log('saveUpdatedParentProducts Completed: ', updateParentProductList.length);
            await updateParentProducts(updateParentProductList);
        }
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    /*const handleSizeTypeChanges = (event) => {
        const {name, value} = event.target;
        const existingParentProduct = {...parentProduct};
        existingParentProduct[name] = value;

        existingParentProduct.isMultiMeasurement = (value === 'single-measurement');

        setParentProduct(existingParentProduct);
    }*/

    return (
        <>

            <div className="-ml-2 mb-6">
                <ParentProductFilters
                    searchProductsList={searchParentProductList}
                    enableEdit={enableEdit}
                    setEnableEdit={setEnableEdit}
                    filterCriteria={filterCriteria}
                    setFilterCriteria={setFilterCriteria}
                    podDetail={podDetail}/>
            </div>

            <div className="table-container overflow-y-scroll border-y border-gray-400 bg-white">
                <table className="w-full">
                    <thead className="">
                    <tr>
                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                        {parentProductFields?.map((field, rowIndex) => (
                            <React.Fragment key={`th-${rowIndex}`}>
                                {!field?.hideInList &&
                                    <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{field?.label}</th>
                                }
                            </React.Fragment>
                        ))}
                        <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Measurement</th>
                    </tr>
                    </thead>
                    <tbody className="">
                    {parentProductList?.map((parentProduct, rowIndex) => (
                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                            <td className="p-2 border border-gray-400 m-auto">
                                {rowIndex + 1}
                            </td>

                            {parentProductFields?.map((field, columnIndex) => (
                                <React.Fragment key={`row-${rowIndex}-column-${columnIndex}`}>
                                    {!field?.hideInList &&
                                        <td key={`column-${rowIndex}-${columnIndex}`}
                                            className={`p-2 border border-gray-400 ${field?.isEditable && enableEdit ? 'bg-gray-200' : ''} ${(field?.attribute === 'colors' || field?.attribute === 'name') ? 'w-1/4' : ''}`}>
                                            {!(field?.isEditable && enableEdit) &&
                                                <>
                                                    {!field?.isList &&
                                                        <>
                                                            {field?.notAvailable &&
                                                                <span
                                                                    className={`${parentProduct[field.notAvailable] ? 'text-red-500 font-semibold' : ''}`}>
                                                                    {parentProduct[field.attribute]}
                                                                </span>
                                                            }

                                                            {!field?.notAvailable &&
                                                                <span>
                                                                    {parentProduct[field.attribute]}
                                                                </span>
                                                            }
                                                        </>
                                                    }

                                                    {field?.isList &&
                                                        <>
                                                            {parentProduct[field.attribute]?.map((item, itemIndex) => (
                                                                <React.Fragment
                                                                    key={`row-${rowIndex}-column-${columnIndex}-item-${itemIndex}`}>{item.name}, </React.Fragment>
                                                            ))}
                                                        </>
                                                    }
                                                </>
                                            }

                                            {field?.isEditable && enableEdit &&
                                                <>
                                                    <input
                                                        type="number"
                                                        className="input-field w-36"
                                                        id={field.attribute}
                                                        name={field.attribute}
                                                        value={parentProduct[field.attribute] || ''}
                                                        onChange={(event) => {
                                                            handleDetailChanges(event, rowIndex, parentProduct);
                                                        }}>
                                                    </input>
                                                </>
                                            }
                                        </td>
                                    }
                                </React.Fragment>
                            ))}

                            <td className={`p-2 border border-gray-400 ${enableEdit ? 'bg-gray-200' : ''}`}>
                                {!enableEdit &&
                                    <select
                                        className="input-field"
                                        id="sizeType"
                                        name="sizeType"
                                        disabled={true}
                                        value={parentProduct?.sizeType}
                                        onChange={(event) => {
                                            handleDetailChanges(event, rowIndex, parentProduct);
                                        }}>
                                        {PRODUCT_SIZE_FILTER_LIST?.map((option, index) => (
                                            <option key={index}
                                                    value={option?.key}>{option?.label}</option>
                                        ))}
                                    </select>
                                }

                                {enableEdit &&
                                    <select
                                        className="input-field"
                                        id="sizeType"
                                        name="sizeType"
                                        value={parentProduct?.sizeType}
                                        onChange={(event) => {
                                            handleDetailChanges(event, rowIndex, parentProduct);
                                        }}>
                                        {PRODUCT_SIZE_FILTER_LIST?.map((option, index) => (
                                            <option key={index}
                                                    value={option?.key}>{option?.label}</option>
                                        ))}
                                    </select>
                                }
                            </td>
                        </tr>

                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default ParentProductList
